// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__9DaRS","label":"styles_label__2VJVt","input":"styles_input__2vubx"};